import classNames from 'classnames';
import CellTooltip from './CellTooltip';
import * as color from '../../../sass/color.scss';

function ApproversCell({
  className,
  style,
  approvers = [],
}) {
  // show extra approvers if more than 5
  const numExtraApprovers = approvers.length - 5;

  // only show 5 approvers max
  if (approvers.length > 5) {
    approvers = approvers.slice(0, 5);
  }

  const avatarStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: -3,
    width: 24,
    height: 24,
    borderRadius: '50%',
    boxSizing: 'border-box',
    backgroundColor: color.gray50,
    border: `1px solid ${color.gray400}`,
    fontSize: 10,
  };

  return (
    <div
      className={classNames('ApproversCell', className)}
      style={{
        display: 'flex',
        alignItems: 'center',
        ...style,
      }}
    >
      {approvers.map((approver, index) => {
        const fname = approver.fname || '';
        const lname = approver.lname || '';
        const displayName = `${fname.substring(0, 1).toUpperCase()}${lname.substring(0, 1).toUpperCase()}`;

        return (
          <CellTooltip
            key={`approver-${approver._id}`}
            title={`${approver.fname} ${approver.lname}`}
          >
            <div
              style={{
                ...avatarStyle,
                // do not move the first avatar
                marginLeft: index === 0
                  ? 0 
                  : avatarStyle.marginLeft,
              }}
            >
              {displayName}
            </div>
          </CellTooltip>
        );
      })}

      {numExtraApprovers > 0 && (
        <div
          style={avatarStyle}
        >
          +{numExtraApprovers}
        </div>
      )}
    </div>
  );
}

export default ApproversCell;
